import React from "react";
import PropTypes from "prop-types";
import chevronRightIcon from "../../../../assets/img/chevron_right_table.svg";
import chevronDownIcon from "../../../../assets/img/chevron_down_sm.svg";

const RatePlanCodeHeader = ({ onToggleExpandAll, allExpanded }) => {
  const handleToggle = (event) => {
    event.stopPropagation();
    onToggleExpandAll();
  };

  const icon = allExpanded ? chevronDownIcon : chevronRightIcon;

  return (
    <div className="rate-plans-derived-rate-page__code-header">
      <button
        type="button"
        className="rate-plans-derived-rate-page__chevron-btn"
        onClick={handleToggle}
        aria-label={allExpanded ? "Collapse all rows" : "Expand all rows"}
      >
        <img src={icon} alt="" width="12" height="12" />
      </button>
      <span>Rate Code</span>
    </div>
  );
};

RatePlanCodeHeader.propTypes = {
  onToggleExpandAll: PropTypes.func.isRequired,
  allExpanded: PropTypes.bool.isRequired,
};

export default RatePlanCodeHeader;
